<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
    <v-dialog v-model="altgruptarihdialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Tarih</v-card-title>
        <v-card-text>
          <v-layout row="" wrap>
            <v-flex xs12 sm12 md12>
              <tarihim :etiket="$t('Date')" v-model="eklenecektarih"></tarihim>
            </v-flex>
            <v-flex xs7>
                <v-text-field v-model="eklenecekGunBaslik " label="Gün Başlığı"></v-text-field>
              </v-flex>
            <v-flex xs12 sm12 md12>
              
              <v-text-field v-model="eklenecektarihaciklama" label="Açıklama"></v-text-field>


            </v-flex>
            <v-flex xs12 sm12 md12>

              <v-select hide-details v-model="eklenecekistipleri" :items="PaketIsTipleri"
                :rules="[(v) => !!v || $t('Mandatory-section')]" item-text="ad" item-value="is" label="İşler" chips
                clearable multiple return-object></v-select>

            </v-flex>




          </v-layout>
          <v-layout row wrap>

            <v-flex xs12 sm12 md12>

              <div class="col-3 pt-2">
                <h3>Seçili İşler</h3>
                <draggable class="list-group" :list="eklenecekistipleri" group="people">
                  <div class="list-group-item2" v-for="(element, index) in eklenecekistipleri" :key="element.ad">
                    {{ element.ad }}
                  </div>
                </draggable>
              </div>
            </v-flex>
          </v-layout>



        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="altgruptarihkaydet()">Kaydet</v-btn>
          <v-btn color="primary" flat @click.native="altgruptarihdialog = false">Kapat</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="altgrupsatisfiyatdialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Fiyat</v-card-title>
        <v-card-text>
          <v-layout row="" wrap>
            <v-flex xs12 sm12 md12>

              <v-flex xs12 sm12 md12>
                <genelarama
                                  :autofocuss="true"
                                  apiname="SaticiAra"
                                  label="Otel"
                                  v-model="selectedaltfiyatgrup.SatisFiyat.Otel"
                                ></genelarama>

            </v-flex>

            </v-flex> <v-flex xs12 sm12 md12>

              <v-text-field v-model="selectedaltfiyatgrup.SatisFiyat.OtelKategori" :autocomplete="'autocomplete'"
              label="Otel Kategori"></v-text-field>

            </v-flex>
            <v-flex xs12 sm12 md12>

              <v-text-field v-model="selectedaltfiyatgrup.SatisFiyat.PansiyonTipi" :autocomplete="'autocomplete'"
              label="Pansiyon Tipi"></v-text-field>

            </v-flex>
            <v-flex xs12 sm12 md12>

              <sayiinput v-model="selectedaltfiyatgrup.SatisFiyat.TekKisiFiyati" :autocomplete="'autocomplete'"
                etiket="Tek Kişi Fiyat"></sayiinput>
            </v-flex>
            <v-flex xs12 sm12 md12>

              <sayiinput v-model="selectedaltfiyatgrup.SatisFiyat.SingleFarki" :autocomplete="'autocomplete'"
                etiket="Single Farkı"></sayiinput>

            </v-flex>
            <v-flex xs12 sm12 md12>

              <sayiinput v-model="selectedaltfiyatgrup.SatisFiyat.UcuncuKisiFiyati" :autocomplete="'autocomplete'"
                etiket="Üçüncü Kişi Fiyatı"></sayiinput>

            </v-flex>
            <v-flex xs12 sm12 md12>

              <sayiinput v-model="selectedaltfiyatgrup.SatisFiyat.CocukFiyati" :autocomplete="'autocomplete'"
                etiket="Çocuk Fiyatı"></sayiinput>

            </v-flex>
            <v-flex xs12 sm12 md12>

              <sayiinput v-model="selectedaltfiyatgrup.SatisFiyat.BebekFiyati" :autocomplete="'autocomplete'"
                etiket="Bebek Fiyatı"></sayiinput>

            </v-flex>
            <v-flex xs12 sm12 md12>

              <v-select hide-details v-model="selectedaltfiyatgrup.SatisFiyat.ParaBirimi" :items="dovizItems"
                :rules="[(v) => !!v || $t('Mandatory-section')]" item-text="Title" item-value="DovizKod"
                :label="$t('Currency-Unit')"></v-select>

            </v-flex>
            <!-- <v-flex xs12 sm12 md12>
                            
                            <sayiinput  v-model="selectedaltfiyatgrup.SatisFiyat.Kur"  :autocomplete="'autocomplete'"  etiket="Kur"></sayiinput>
                         
                          </v-flex> -->
          </v-layout>




        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.native="altgrupsatisfiyatdialog = false">Kapat</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="fiyatAltgrupdialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Fiyat Alt Grubu</v-card-title>
        <v-card-text>
          <v-layout>
            <v-flex xs12 sm12 md12>
              <v-select label="Fiyat Alt Grubu" item-text="Aciklama" item-value="Id" :items="fiyatAltGruplar"
                v-model="fiyatAltGrup" return-object></v-select>
            </v-flex>

          </v-layout>




        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.native="fiyatAltgrupdialog = false">İptal</v-btn>
          <v-btn color="primary" flat @click="ProgramAltFiyatGrupEkle()">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="fiyatgrupdialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Fiyat Grubu</v-card-title>
        <v-card-text>
          <v-layout>
            <v-flex xs12 sm12 md12>
              <v-select label="Fiyat Ana Grubu" item-text="Aciklama" item-value="Id" :items="fiyatAnaGruplar"
                v-model="fiyatAnaGrup" return-object></v-select>
            </v-flex>

          </v-layout>




        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click.native="fiyatgrupdialog = false">İptal</v-btn>
          <v-btn color="primary" flat @click="ProgramFiyatGrupEkle()">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-card height="100%" color="grey lighten-5" flat>
      <v-form>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar class="baslik" size="120px" dark color="info">
              <v-toolbar-title>Tur Alt Paket </v-toolbar-title>
              <v-spacer></v-spacer>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="kaydet()" flat> <span
                    class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{ $t('save_button') }} </span>
                  </span>
                  <v-icon right dark>add_box</v-icon>

                </v-btn>

              </v-tooltip>
              <v-menu bottom="">
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>

                <v-list>
                  <a target="_self" v-bind:href="'#/pakettur/turaltpaket/'">

                    <v-list-tile>
                      <v-list-tile-title>{{ $t('cancel_button') }}</v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>

              </v-menu>

            </v-toolbar>
          </v-flex>

          <v-tabs style="width:100%;" dark="" color="blue darken-3" slot="extension" slider->
            <v-tabs-slider></v-tabs-slider>
            <v-tab href='#0'>
              {{ $t("tab_general") }}
            </v-tab>
            <v-tab-item :id="'0'" style="width:100%; height:500px;">
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs9 md3 sm9>
                            <v-text-field label="Kod" maxlength="50" hide-details="" v-model="turKodu">

                            </v-text-field>

                          </v-flex>
                          <v-flex xs9 md7 sm8>
                            <v-text-field label="Adı" maxlength="250" hide-details="" v-model="turAdi">

                            </v-text-field>

                          </v-flex>
                          <v-flex xs9 md2 sm8>
                            <v-checkbox label="Aktif" v-model="turAktif"></v-checkbox>

                          </v-flex>
                          <v-flex xs9 md6 sm12>
                            <v-select label="Kategori" item-text="Aciklama" item-value="Id" :items="kategoriler"
                              v-model="turKategoriID"></v-select>

                          </v-flex>
                          <v-flex xs9 md6 sm12>
                            <v-select label="Ürün Grubu" item-text="Aciklama" item-value="Id" :items="urungruplari"
                              v-model="turUrunGrupID"></v-select>

                          </v-flex>
                          <v-flex xs9 md4 sm8>
                            <v-text-field label="Gündüz" maxlength="15" hide-details="" v-model="turGunduz"
                              type="number">

                            </v-text-field>

                          </v-flex>
                          <v-flex xs9 md4 sm8>
                            <v-text-field label="Gece" maxlength="15" hide-details="" v-model="turGece" type="number"
                              required>

                            </v-text-field>

                          </v-flex>
                          <v-flex xs9 md4 sm8>
                            <v-text-field label="Kontenjan" maxlength="15" hide-details="" v-model="turKontenjan"
                              type="number" required>

                            </v-text-field>

                          </v-flex>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>

                </v-flex>
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs9 md12 sm12>
                            <v-autocomplete v-model="BaslangicNoktasi" label="Başlangıç Noktası" item-text="Title"
                              item-value="ParkurKod" :items="Parkurs"></v-autocomplete>


                          </v-flex>
                          <v-flex xs9 md6 sm12>
                            <v-autocomplete v-model="VarisParkur" label="Varış Parkur" item-text="Title"
                              item-value="ParkurKod" :items="Parkurs"></v-autocomplete>
                          </v-flex>
                          <v-flex xs9 md6 sm12>
                            <v-autocomplete v-model="DonusParkur" label="Dönüş Parkur" item-text="Title"
                              item-value="ParkurKod" :items="Parkurs"></v-autocomplete>

                          </v-flex>
                          <v-flex xs9 md12 sm12>
                            <v-textarea v-model="turNotlar" :label="$t('Notes')"></v-textarea>
                          </v-flex>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>


            </v-tab-item>

            <v-tab href='#1' ripple>
              {{ 'Resimler' }}
            </v-tab>
            <v-tab-item :id="'1'" style="width:100%; height:100%;">
              <v-layout row wrap>
                <v-container fluid>
                  <v-card color="grey lighten-5">
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md2>
                        <v-layout align-center justify-start row fill-height>
                          <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data"
                            lazy-validation>
                            <input hidden type="file" id="files" ref="files" multiple />
                          </v-form>
                          <v-btn :loading="false" :disabled="false" color="info" dark>
                            <input class="custom-file-input" type="file" :label="$t('Select-File')" id="files"
                              ref="files" @change="onFileChange" accept="image/jpeg" multiple />
                            <v-icon color="white" left>attach_file</v-icon> {{ 'Eklenecek Resim Dosyası Seçin' }}
                          </v-btn>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                      </v-flex>

                    </v-layout>
                  </v-card>
                </v-container>

              </v-layout>
              <v-layout row="" wrap="">
                <v-container fluid>

                  <v-layout row="" wrap="">


                    <v-flex v-for="file in uploadedFiles" pa-1 xs12 sm6 md3>
                      <v-card>
                        <v-card-text>
                          <v-img class="bg-grey-lighten-2 w-100" :src="onFileUrlGet(file)"></v-img>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn @click="deleteUploadedFile(file.name)" flat icon color="">
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-flex>
                    <v-flex v-for="file in files" pa-1 xs12 sm6 md3>
                      <v-card :class="file.silinecek === true ? 'red' : file.IsMain === true ? 'blue' : ''">
                        <v-card-text>
                          <v-img class="bg-grey-lighten-2 w-100" :src="file.url"></v-img>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn @click="setDeletedImage(file.Id)" flat icon color="">
                            <v-icon>delete</v-icon>
                          </v-btn>
                          <v-btn @click="setIsMainImage(file.Id)" flat icon color="">
                            <v-icon>star</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-layout>

            </v-tab-item>

            <v-tab href='#2' ripple>
              {{ $t('Program') }}
            </v-tab>


            <v-tab-item :id="'2'" class="pa-2">


              <v-layout row wrap>


                <v-expansion-panel>

                  <v-expansion-panel-content v-for="(anagrup, i) in this.Programlar.FiyatGruplari" :key="i"
                    style="background:#26c6da;color:white;font-weight:bold;">
                    <template v-slot:header>
                      <div>{{ anagrup.FiyatGrubu.isim }}</div>
                      <v-spacer></v-spacer>
                    </template>
                    <v-card>
                      <v-layout row="" wrap="">

                        <v-expansion-panel class="ma-4 pa-4 w-100">
                          <v-expansion-panel-content v-for="(altgrup, ialt) in anagrup.AltGruplar" :key="ialt"
                            style="background:#90CAF9;font-weight:bold;">
                            <template v-slot:header>
                              <div>{{ anagrup.FiyatGrubu.isim }} > {{ altgrup.AltGrup.isim }} </div>
                              <v-spacer></v-spacer>
                            </template>

                            <div>

                              <v-layout row wrap>
                                <!-- altgrupalitindaki tarihler -->
                                <v-flex xs12 sm12 md12>
                                  <v-toolbar flat>

                                    {{ 'Program' }}


                                    <v-spacer></v-spacer>

                                    <v-btn icon small flat>
                                      <v-icon color="info"
                                        @click="altgruptarihdialogac(anagrup, altgrup)">add_box</v-icon>
                                    </v-btn>

                                  </v-toolbar>
                                  <v-card class="white--text">
                                    <v-data-table :headers="headersprogramisler" :items="altgrup.Tarihler" hide-actions
                                      class="elevation-1">


                                      <template slot="items" slot-scope="props">

                                        <tr item v-if="!props.item.silinecek">
                                          <td class="text-left font-weight-black">
                                            {{ props.item.Tarih | dateformat }}
                                          </td>
                                          <td>
                                            {{ props.item.Aciklama }}
                                          </td>
                                          <td class="text-left font-weight-black">


                                            <span v-for="tag in props.item.Isler">
                                              <v-chip draggable v-if="!tag.silinecek" close
                                                @input="tarihiskaldir(anagrup, altgrup, props.item.Tarih, tag)">
                                                {{ tag.isim }}
                                              </v-chip>

                                            </span>

                                          </td>
                                          <td class="text-xs-center">
                                            <v-btn color="info"
                                              @click="tarihEditDialogOpen(anagrup, altgrup, props.item)" icon small
                                              flat>
                                              <v-icon>edit</v-icon>
                                            </v-btn>
                                            <v-btn icon small flat>
                                              <v-icon color="warning"
                                                @click="tarihDeleteDialogOpen(anagrup, altgrup, props.item)">delete</v-icon>
                                            </v-btn>
                                          </td>
                                        </tr>



                                      </template>

                                    </v-data-table>

                                  </v-card>
                                </v-flex>

                              </v-layout>

                            </div>
                          </v-expansion-panel-content> </v-expansion-panel>




                      </v-layout>

                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-layout>
            </v-tab-item>



            <v-tab href='#3' ripple>
              {{ $t('Price') }}
            </v-tab>

            <v-tab-item :id="'3'">

              <v-layout row="" wrap>


                <v-flex xs12 sm12 md12 lg12 pa-2>
                  <v-card>
                    <v-card-title>
                      <p class="font-weight-black">Alt Paket Fiyatlar</p>
                      <v-spacer></v-spacer>

                      <v-select label="Fiyat Grubu" item-text="FiyatGrubu.isim" item-value="FiyatGrubu.id"
                        :items="Programlar.FiyatGruplari" v-model="selectedfiyatgrup" return-object></v-select>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-data-table :headers="headersfiyatalt" :loading="progress" :items="selectedfiyatgrup.AltGruplar"
                        :hide-default-footer="true">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                        <template slot="items" slot-scope="props">
                          <tr item>
                            <td @click="selectedPaketAltGrup = props.item" class="text-xs-left">{{
                              props.item.AltGrup.isim }}</td>
                            <td class="text-xs-left">{{ props.item.SatisFiyat.Otel.isim }}</td>
                            <td class="text-xs-left">{{ props.item.SatisFiyat.OtelKategori }}</td>
                            <td class="text-xs-left">{{ props.item.SatisFiyat.PansiyonTipi }}</td>
                            <td class="text-xs-left">{{ props.item.SatisFiyat.TekKisiFiyati }}</td>
                            <td class="text-xs-left">{{ props.item.SatisFiyat.SingleFarki }}</td>
                            <td class="text-xs-left">{{ props.item.SatisFiyat.UcuncuKisiFiyati }}</td>
                            <td class="text-xs-left">{{ props.item.SatisFiyat.CocukFiyati }}</td>
                            <td class="text-xs-left">{{ props.item.SatisFiyat.BebekFiyati }}</td>
                            <td class="text-xs-left">{{ props.item.SatisFiyat.ParaBirimi }}</td>
                            <td class="justify-center align-center full-heigth layout px-0">
                              <v-btn @click="altgrupfiyatguncelledialog(props.item.AltGrup.isim)" icon small flat>
                                <v-icon color="info">edit</v-icon>
                              </v-btn>

                            </td>
                            <!-- <td class="text-xs-left">{{ props.item.SatisFiyat.Kur }}</td> -->


                          </tr>
                        </template>

                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-layout row="" wrap v-if="selectedPaketAltGrup !== null" justify-space-around>
                  <v-flex xs-5 sm5 md5 lg5 mr2>
                    <v-card>
                      <v-card-title>
                        <p class="font-weight-black">Acente Ekle</p>
                        <v-spacer></v-spacer>
                      </v-card-title>
                      <v-text-field :label="this.$t('Search-(minumum-3-characters)')" flat="" solo-inverted=""
                        hide-details append-icon="search" @change="AcenteBul"></v-text-field>
                      <v-data-table :headers="headersIzinVerilenAcenteler" :loading="progress" :items="acenteList"
                        :hide-default-footer="true">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                        <template slot="items" slot-scope="props">
                          <tr item>
                            <td class="text-xs-left">{{ props.item.Kod }}</td>
                            <td class="justify-center align-center full-heigth layout px-0">
                              <v-btn @click="AcenteAltGrupIzinVer(props.item.Kod)" icon small flat>
                                <v-icon color="add">add_box</v-icon>
                              </v-btn>

                            </td>
                            <!-- <td class="text-xs-left">{{ props.item.SatisFiyat.Kur }}</td> -->


                          </tr>
                        </template>

                      </v-data-table>
                    </v-card>
                  </v-flex>
                  <v-flex xs-12 sm12 md12 lg6>
                    <v-card>
                      <v-card-title>
                        <p class="font-weight-black">Satışına İzin Verilen Acenteler</p>
                        <v-spacer></v-spacer>
                      </v-card-title>
                      <v-data-table :headers="headersIzinVerilenAcenteler" :loading="progress"
                        :items="selectedPaketAltGrup.PaketAltGrupAcenteler" :hide-default-footer="true">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                        <template slot="items" slot-scope="props">
                          <tr item :class="props.item.silinecek ? 'red' : 'white'">
                            <td class="text-xs-left">{{ props.item.AcentaKod }}</td>
                            <td class="justify-center align-center full-heigth layout px-0">
                              <v-btn @click="izinVerilenAcenteKaldır(props.item.AcentaKod, selectedPaketAltGrup.Id)"
                                icon small flat>
                                <v-icon color="delete">delete</v-icon>
                              </v-btn>

                            </td>
                            <!-- <td class="text-xs-left">{{ props.item.SatisFiyat.Kur }}</td> -->


                          </tr>
                        </template>

                      </v-data-table>
                    </v-card>
                  </v-flex>

                </v-layout>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-layout>
      </v-form>

    </v-card>
  </div>
</template>

<script>
import auth from '../../../api/auth'
import parainput from '../customcomp/parainput'
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
import tarihim from "@/components/app/customcomp/tarihim.vue"
import tool from "../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js"
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import cariaracomp from '@/components/app/customcomp/cariaracomp'
import analizcomp from '@/components/app/bilet/partpage/analizcomp'
import loadingcomp from "@/components/app/customcomp/loadingcomp"
import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp'
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import sayiinput from '@/components/app/customcomp/sayiinput.vue';
import draggable from "vuedraggable";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
export default {
  data() {
    return {
      files: [],
      uploadedFiles: [],
      eklenecekistipleri: [],
      selectedtarih: {
        Isler: [],
        Tarih: null,
        Aciklama: '',
      },
      tarihupdate: false,
      altgrupsatisfiyatdialog: false,
      selectedfiyatgrup: {
        AltGruplar: []
      },
      selectedaltfiyatgrup: {
        Tarihler: [],
        SatisFiyat: {
          TekKisiFiyati: 0.0,
          SingleFarki: 0.0,
          UcuncuKisiFiyati: 0.0,
          CocukFiyati: 0.0,
          BebekFiyati: 0.0,
          ParaBirimi: "",
          Kur: 0.0
        },

      },
      fiyatgrupdialog: false,
      fiyatAltgrupdialog: false,
      dovizItems: [],
      eklenecekistipi: null,
      eklenecektarih: null,
      eklenecektarihaciklama: null,
      eklenecekGunBaslik:"",
      altgruptarihdialog: false,
      PaketIsTipleri: [
        {
          ad: 'Ucus',
          id: 1
        },
        {
          ad: 'GelisTransferi',
          id: 2
        },
        {
          ad: 'GidisTransferi',
          id: 3
        },
        {
          ad: 'Tasima',
          id: 4
        },
        {
          ad: 'Otel',
          id: 5
        },
        {
          ad: 'Restaurant',
          id: 6
        },
        {
          ad: 'Rehber',
          id: 7
        },
        {
          ad: 'ArabaKiralama',
          id: 8
        },
        {
          ad: 'Muze',
          id: 9
        },
        {
          ad: 'Diger',
          id: 10
        },
        {
          ad: 'GunlukSehirTuru',
          id: 11
        },
        {
          ad: 'TamGunBosAyak',
          id: 12
        },
        {
          ad: 'YarimGunBosAyak',
          id: 13
        },
        {
          ad: 'Gemi',
          id: 14
        },
      ],
      Programlar: {
        FiyatGruplari: [],
      },
      snackbar: false,
      progress: false,
      credentials: null,
      Parkurs: [],


      fiyatAnaGruplar: [],
      fiyatAltGruplar: [],
      kategoriler: [],
      urungruplari: [],
      headersIzinVerilenAcenteler: [
        { text: 'Acente Kodu', value: 'AcentaKod' },
        { text: 'İşlem', align: 'center' },
      ],
      headersprogramisler: [
        {
          text: 'Tarih',
          value: 'Tarih'
        },
        {
          text: 'Açıklama',
          value: 'Aciklama'
        },
        {
          text: 'İş Tipi',
          value: 'isim'
        },
        {
          text: 'İşlem',
          align: 'center'
        },
      ],

      headersfiyatalt: [
        {
          text: 'Alt Grup',

        },
        {
          text:'Otel',
          value:'Otel'
        },
        {
          text:'Otel Kategori',
          value:'OtelKategori'
        },
        {
          text:'Pansiyon Tipi',
          value:'PansiyonTipi'
        },
        {
          text: 'Tek Kişi',
          value: 'TekKisiFiyati'
        },
        {
          text: 'Single Farkı',
          value: 'SingleFarki'
        },
        {
          text: 'Üçüncü Kişi ',
          value: 'UcuncuKisiFiyati'
        },

        {
          text: 'Çocuk',
          value: 'CocukFiyati'
        },
        {
          text: 'Bebek',
          value: 'BebekFiyati'
        },
        {
          text: 'PB',
          value: 'ParaBirimi'
        },
        // {
        //   text: 'Kur',
        //   value: 'Kur'
        // },
        {
          text: 'Güncelle',

        },
      ],
      PB: "TRY",
      tumsirketler: false,
      currentCheck: {},
      sablonSelectedItem: {
        design: []
      },
      sablonData: null,
      itemsSablon: [],
      itemsSablonSelected: [],
      counter: 0,
      loadingvmodel: false,
      videodialog: false,
      sayfayetki: {
        Screen: true,
        Update: true,
        Save: true,
        Delete: true,
        Status: true,
        Message: null,
        islem: 0,
      },

      prevRoute: null,

      mukellefScroll: false,
      hesapgurubu: [],
      dialogfiltre: false,
      cokluposta: false,
      postaitems: [],
      valid: true,
      tabcontrol3: 0,
      drawer: null,
      baslik: '',
      e1: 0,
      Code: '',
      e2: true,
      yok: false,
      statecari: [],
      search: '',
      search1: '',
      loading: false,
      dictionary: {
        custom: {
          carikod: {
            required: () => this.$t('This-space-cannot-left-blank'),
          },
          unvan: {
            required: () => this.$t('This-space-cannot-left-blank'),
          },

        }
      },
      text1: null,
      MasterTurId: 0,
      fiyatAltGrup: null,
      fiyatAnaGrup: null,
      PaketTurIsTarih: null,
      kaydetbuton: false,
      turKategoriID: null,
      turUrunGrupID: null,
      turAdi: null,
      turKodu: null,
      turGece: null,
      turGunduz: null,
      turAktif: false,
      turKontenjan: null,
      turId: 0,
      turNotlar: null,
      isUpdate: false,
      selectedPaketAltGrup: null,
      acenteList: [],
      BaslangicNoktasi: null,
      VarisParkur: null,
      DonusParkur: null,
      BaslangicTarihi:new Date(),
      BitisTarihi:new Date(),
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path
    })
  },

  mounted() {
    this.$validator.localize('en', this.dictionary)
    if (this.$route.query.id > 0) {
      this.isUpdate = true;
    }
    this.credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.getParaBirimleri();
    this.getParkurs();
    this.getkategoriler();
    this.geturungruplari();

    let params = {
      TanitimTip: 11,
    };

    tool.http_post(this, "GenelTipTanitimList", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.fiyatAnaGruplar = response.body.data;

          let paramsalt = {
            TanitimTip: 12,
          };

          tool.http_post(this, "GenelTipTanitimList", paramsalt).then(
            (response) => {
              if (response.body.Status == true) {
                this.fiyatAltGruplar = response.body.data;

                if (this.isUpdate) {
                  this.turId = this.$route.query.id;
                  this.MasterTurLoad();
                }
                else {
                  this.programolustur();
                }

              } else {
                this.text1 = response.body.ErrorList[0];
                this.snackbar = true;
              }
            },

            (response) => {
              this.text1 = $t('Error-Occured-Please-Try-Again')
              this.snackbar = true;
            }
          );



        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
        }
      },

      (response) => {
        this.text1 = $t('Error-Occured-Please-Try-Again')
        this.snackbar = true;
      }
    );

  },
  methods: {
    onFileChange(e) {
      let files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        let element = files[i];
        console.log(element, "element")
        this.uploadedFiles.push(element)
      }
      //this.uploadedFiles = e.target.files;
    },
    onFileUrlGet(file) {
      console.log(file, "urlobject")
      return URL.createObjectURL(file);
    },
    setDeletedImage(id) {
      var i = this.files.findIndex(x => x.Id == id)
      this.files[i].silinecek = true;
      console.log("this.files", this.files)
    },
    setIsMainImage(id) {
      var copyImages = this.files;
      this.files = [];
      for (let i = 0; i < copyImages.length; i++) {
        let element = copyImages[i];
        this.files.push({
          Id: element.Id,
          url: element.url,
          IsMain: element.Id === id ? true : false,
          silinecek: element.silinecek
        })

      }
      console.log("this.files", this.files)
    },
    deleteUploadedFile(name) {
      this.uploadedFiles = this.uploadedFiles.filter(x => x.name !== name)
    },
    programolustur() {
      this.fiyatAnaGruplar.forEach((valueana, indexana) => {
        var anagrup = {
          Id: 0,
          FiyatGrubu: {
            id: valueana.Id,
            isim: valueana.Ad,
            kod: valueana.Ad
          },
          AltGruplar: []
        }
        this.fiyatAltGruplar.forEach((valuealt, indexalt) => {
          var altgrup = {
            Id: 0,
            AltGrup: {
              id: valuealt.Id,
              isim: valuealt.Ad,
              kod: valuealt.Ad
            },
            Tarihler: [],
            SatisFiyat: {
              TekKisiFiyati: 0.0,
              SingleFarki: 0.0,
              UcuncuKisiFiyati: 0.0,
              CocukFiyati: 0.0,
              BebekFiyati: 0.0,
              ParaBirimi: "",
              Kur: 0.0,
              Otel: "",
              OtelKategori: "",
              PansiyonTipi: ""
            },
          }
          anagrup.AltGruplar.push(altgrup);

        })
        this.Programlar.FiyatGruplari.push(anagrup);
      })





      console.log(this.Programlar);
    },
    tarihiskaldir(anax, altx, tarihx, isx) {

      console.log(isx);
      if (isx.Id > 0) {
        isx.silinecek = true;
        var restarih = resalt.Tarihler.find(x => x.Tarih == tarihx);
        if (restarih.Isler.find(x => x.silinecek == false) == 0) {
          restarih.gosterTarih = false;
        }
        return;
      }

      let resana = this.Programlar.FiyatGruplari.find(x => x.FiyatGrubu.isim == anax.FiyatGrubu.isim);
      if (resana != null) {
        var resalt = resana.AltGruplar.find(x => x.AltGrup.isim == altx.AltGrup.isim);
        if (resalt != null) {
          var restarih = resalt.Tarihler.find(x => x.Tarih == tarihx);
          if (restarih != null) {
            restarih.Isler = restarih.Isler.filter((obj) => {
              return obj.isim !== isx.isim;
            })

          }
        }
      }

    },
    altgruptarihkaydet() {
      var tarih = {
        Tarih: this.eklenecektarih,
        Aciklama: this.eklenecektarihaciklama,
        Isler: [],
        GunBaslik:"",
        Gun:"",
        gosterTarih: true,
      }

      this.eklenecekistipleri.forEach((valueis, indexis) => {
        if(valueis.id > 0){
          console.log(valueis,"vALUEİS")
          var istipi = { Id: 0, IsTipi: valueis.id, isim: valueis.ad, silinecek: false };
          tarih.Isler.push(istipi);
        }
      })

      if (this.tarihupdate) {
        this.selectedtarih.Isler.forEach((valueeski, indexeski) => {
            var istipi = { Id: valueeski.Id, IsTipi: valueeski.IsTipi, isim: valueeski.isim, silinecek: false };
            tarih.Isler.push(istipi);
        })

        let resana = this.Programlar.FiyatGruplari.find(x => x.FiyatGrubu.isim == this.selectedfiyatgrup.FiyatGrubu.isim);
        if (resana != null) {
          var resalt = resana.AltGruplar.find(x => x.AltGrup.isim == this.selectedaltfiyatgrup.AltGrup.isim);
          if (resalt != null) {
            var restarih = resalt.Tarihler.find(x => x.Tarih == this.selectedtarih.Tarih);
            if (restarih != null) {
              const farkMilisaniye = Math.abs(new Date(this.eklenecektarih) - new Date(this.BaslangicTarihi));
              const farkGun = Math.ceil(farkMilisaniye / (1000 * 60 * 60 * 24));
              restarih.Aciklama = this.eklenecektarihaciklama;
              restarih.Tarih = this.eklenecektarih;
              restarih.Isler = [];
              restarih.Isler = tarih.Isler;
              restarih.GunBaslik = this.eklenecekGunBaslik;
              restarih.Gun = farkGun;
            }
          }
        }
      }
      else {
        let resana = this.Programlar.FiyatGruplari.find(x => x.FiyatGrubu.isim == this.selectedfiyatgrup.FiyatGrubu.isim);
        if (resana != null) {
          const farkMilisaniye = Math.abs(new Date(this.eklenecektarih) - new Date(this.BaslangicTarihi));
          const farkGun = Math.ceil(farkMilisaniye / (1000 * 60 * 60 * 24));
          tarih.Gun = farkGun;
          var resalt = resana.AltGruplar.find(x => x.AltGrup.isim == this.selectedaltfiyatgrup.AltGrup.isim);
          resalt.Tarihler.push(tarih);
        }
      }
      this.altgruptarihdialog = false;
      this.tarihupdate = false;
      this.eklenecekGunBaslik = '';
      this.eklenecektarihaciklama = '';
      this.eklenecekistipleri = [];
      this.eklenecektarih = null;
    },
    altgruptarihdialogac(anax, altx) {
      this.selectedfiyatgrup = anax;
      var resalt = anax.AltGruplar.find(x => x.AltGrup.isim == altx.AltGrup.isim);
      console.log(resalt);
      if (resalt != null) {
        this.selectedaltfiyatgrup = resalt;
        this.altgruptarihdialog = true;
      }
    },
    altgrupfiyatguncelledialog(altgrupisim) {
      let res = this.selectedfiyatgrup.AltGruplar.find(x => x.AltGrup.isim == altgrupisim);
      this.selectedaltfiyatgrup = res;
      this.altgrupsatisfiyatdialog = true;
    },
    tarihEditDialogOpen(anax, altx, tarihx) {
      this.selectedfiyatgrup = anax;
      this.selectedaltfiyatgrup = altx;
      this.selectedtarih = tarihx;

      let resana = this.Programlar.FiyatGruplari.find(x => x.FiyatGrubu.isim == anax.FiyatGrubu.isim);
      if (resana != null) {
        var resalt = resana.AltGruplar.find(x => x.AltGrup.isim == altx.AltGrup.isim);
        if (resalt != null) {
          var restarih = resalt.Tarihler.find(x => x.Tarih == tarihx.Tarih);
          if (restarih != null) {
            this.eklenecektarih = restarih.Tarih;
            this.eklenecektarihaciklama = restarih.Aciklama;
            this.eklenecekGunBaslik = restarih.GunBaslik;
            this.eklenecekGun = restarih.Gun;
            this.eklenecekistipleri = [];
            restarih.Isler.forEach((valueis, indexis) => {
              if (!valueis.silinecek) {
                var istipi = { id: valueis.id, ad: valueis.isim };
                this.eklenecekistipleri.push(istipi);
              }
            })
            this.tarihupdate = true;
            this.altgruptarihdialog = true;

          }
        }
      }
    },
    tarihDeleteDialogOpen(anax, altx, tarihx) {
      if (confirm('Seçili Tarihi Silmek İstiyor musunuz..?')) {
        let resana = this.Programlar.FiyatGruplari.find(x => x.FiyatGrubu.isim == anax.FiyatGrubu.isim);
        if (resana != null) {
          var resalt = resana.AltGruplar.find(x => x.AltGrup.isim == altx.AltGrup.isim);
          if (resalt != null) {
            let ucur = true;
            var restarih = resalt.Tarihler.find(x => x.Tarih == tarihx.Tarih);
            restarih.Isler.forEach((valueis, indexis) => {
              valueis.silinecek = true;
              if (valueis.Id > 0) {
                ucur = false;
              }
            })

            if (ucur) {
              resalt.Tarihler = resalt.Tarihler.filter((obj) => {
                return obj.Tarih !== tarihx.Tarih;
              })
            }
            else {
              restarih.gosterTarih = false;
            }
          }
        }
      }
    },
    getParaBirimleri() {
      var params = {
        CompanyCode: this.credentials.SirketKodu,
      };
      this.$http
        .post(auth.API_URL + "api/currency/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.dovizItems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz";
              this.snackbar = true;
            }
          }
        );
    },
    ProgramIsEkle() {
      let res = this.selectedaltfiyatgrup.Tarihler.find(x => x.Tarih == this.eklenecektarih);
      if (res == null || res == 'undefined') {
        var tarih = {
          Tarih: this.eklenecektarih,
          Isler: [
            {
              Id: 0,
              IsTipi: this.eklenecekistipi.id,
              isim: this.eklenecekistipi.ad
            },
          ],
        }
        this.selectedaltfiyatgrup.Tarihler.push(tarih);
      }
      else {
        let istipi = {
          Id: 0,
          IsTipi: this.eklenecekistipi.id,
          isim: this.eklenecekistipi.ad

        }
        res.Isler.push(istipi);
      }
    },
    altgrupfiyatguncelledialog(altgrupisim) {
      let res = this.selectedfiyatgrup.AltGruplar.find(x => x.AltGrup.isim == altgrupisim);
      this.selectedaltfiyatgrup = res;
      this.altgrupsatisfiyatdialog = true;
    },
    ProgramAltFiyatGrupDialog() {

      this.fiyatAltgrupdialog = true;
    },
    ProgramAltFiyatGrupEkle() {
      let res = this.Programlar.FiyatGruplari.find(x => x.FiyatGrubu.isim == this.selectedfiyatgrup.FiyatGrubu.isim);
      var altg = {
        Id: 0,
        AltGrup: {
          id: this.fiyatAltGrup.Id,
          kod: this.fiyatAltGrup.Aciklama,
          isim: this.fiyatAltGrup.Aciklama,
          tip: 0,
          intField: null,
          tumSirketler: false,
          sayfaAdi: null,
        },
        Tarihler: [

        ],
        SatisFiyat: {
          TekKisiFiyati: 0.0,
          SingleFarki: 0.0,
          UcuncuKisiFiyati: 0.0,
          CocukFiyati: 0.0,
          BebekFiyati: 0.0,
          ParaBirimi: "",
          Kur: 0.0,
          Otel: "",
          OtelKategori: "",
          PansiyonTipi: ""
        },
      }
      res.AltGruplar.push(altg);
      this.fiyatAltgrupdialog = false;
      this.selectedaltfiyatgrup = altg;
    },
    ProgramFiyatGrupDialog() {

      this.fiyatgrupdialog = true;
    },
    ProgramFiyatGrupEkle() {
      let fgrup = {
        Id: 0,
        FiyatGrubu: {
          id: this.fiyatAnaGrup.Id,
          kod: this.fiyatAnaGrup.Ad,
          isim: this.fiyatAnaGrup.Aciklama,
          tip: 0,
          intField: null,
          tumSirketler: false,
          sayfaAdi: null
        },
        AltGruplar: [
        ]
      };
      this.Programlar.FiyatGruplari.push(fgrup);
      this.fiyatgrupdialog = false;
      this.selectedfiyatgrup = fgrup;
    },
    MasterTurLoad() {

      let params = {
        Id: this.turId,
        tumSirketler: false,
        sayfaAdi: null,
      };
      tool.http_post(this, "PaketLoad", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.MasterTurId = response.body.data.MasterTurId;
            this.turAdi = response.body.data.TurAdi;
            this.turKodu = response.body.data.TurKodu;
            this.turNotlar = response.body.data.Notlar;
            this.turGece = response.body.data.Gece;
            this.turGunduz = response.body.data.Gunduz;
            this.turAktif = response.body.data.Aktif;
            this.turKategoriID = parseInt(response.body.data.Kategori.id);
            this.turUrunGrupID = parseInt(response.body.data.UrunGrubu.id);
            this.turKontenjan = response.body.data.Kontenjan;
            this.Programlar = response.body.data.Program;
            this.BaslangicNoktasi = response.body.data.BaslangicNoktasi;
            this.DonusParkur = response.body.data.DonusParkur;
            this.VarisParkur = response.body.data.VarisParkur;
            this.BaslangicTarihi= response.body.data.BaslangicTarihi;
            this.BitisTarihi= response.body.data.BitisTarihi;

            let resimler = response.body.data.PaketResimler.Resimler;
            for (let i = 0; i < resimler.length; i++) {
              let resim = resimler[i];
              this.getImage(resim)
            }
            if (response.body.data.Program.FiyatGruplari.length > 0) {

              this.selectedfiyatgrup = response.body.data.Program.FiyatGruplari[0];
              if (this.selectedfiyatgrup.AltGruplar.length > 0) {
                this.selectedfiyatgrup.AltGruplar.forEach((valueis, indexis) => {
                  valueis.Tarihler.forEach((valuetarih, indextarih) => {
                    valuetarih.Isler.forEach((valueis, indexis) => {
                      valuetarih.gosterTarih = true;
                      let res = this.PaketIsTipleri.find(x => x.id == valueis.IsTipi);
                      console.log(valueis.IsTipi,"iştipi")
                      console.log("ressss",res,this.PaketIsTipleri)
                      valueis.isim = res.ad;
                      valueis.gosterTarih = true;
                    })
                  })

                })
                this.selectedaltfiyatgrup = this.selectedfiyatgrup.AltGruplar[0];
                if (this.selectedaltfiyatgrup.Tarihler.length > 0) {

                }
              }

            }


          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
    },

    base64toBlob(base64Data, contentType) {
      contentType = contentType || "";
      var sliceSize = 1024;
      var byteCharacters = atob(base64Data);
      var bytesLength = byteCharacters.length;
      var slicesCount = Math.ceil(bytesLength / sliceSize);
      var byteArrays = new Array(slicesCount);

      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return new Blob(byteArrays, { type: contentType });
    },

    kaydet() {

      var prmprogramlar = {
        FiyatGruplari: [],
      };

      this.Programlar.FiyatGruplari.forEach((value, index) => {
        var grup = { Id: value.Id, FiyatGrubuId: value.FiyatGrubu.id, silinecek: "false", AltGruplar: [] };
        value.AltGruplar.forEach((valuealt, indexalt) => {
          var altgrup = {
            Id: valuealt.Id, AltGrupId: valuealt.AltGrup.id, Tarihler: [],
            SatisFiyat: {
              TekKisiFiyati: valuealt.SatisFiyat.TekKisiFiyati,
              SingleFarki: valuealt.SatisFiyat.SingleFarki,
              UcuncuKisiFiyati: valuealt.SatisFiyat.UcuncuKisiFiyati,
              CocukFiyati: valuealt.SatisFiyat.CocukFiyati,
              BebekFiyati: valuealt.SatisFiyat.BebekFiyati,
              ParaBirimi: valuealt.SatisFiyat.ParaBirimi,
              Kur: valuealt.SatisFiyat.Kur,
              Otel: valuealt.SatisFiyat.Otel,
              OtelKategori:valuealt.SatisFiyat.OtelKategori,
              PansiyonTipi:valuealt.SatisFiyat.PansiyonTipi
            }
          };
          valuealt.Tarihler.forEach((valuetarih, indextarih) => {
            var tarihprm = { Tarih: valuetarih.Tarih, Isler: [], Gun: valuetarih.Gun,Aciklama:valuetarih.Aciklama };
            valuetarih.Isler.forEach((valueis, indexis) => {
              tarihprm.Isler.push({ Id: valueis.Id, IsTipi: valueis.IsTipi, silinecek: valueis.silinecek });
            })
            altgrup.Tarihler.push(tarihprm);

          })
          altgrup.PaketAltGrupAcenteler = []
          valuealt.PaketAltGrupAcenteler.forEach((value, index) => {
            var acente = {
              Id: value.Id,
              AcentaKod: value.AcentaKod,
              PaketAltGrupId: value.PaketAltGrupId,
              silinecek: value.silinecek
            }
            altgrup.PaketAltGrupAcenteler.push(acente)
          })

          grup.AltGruplar.push(altgrup);
        }

        )
        prmprogramlar.FiyatGruplari.push(grup);
      });

      let params = {
        MasterTurId: this.MasterTurId,
        Id: this.turId,
        TurKodu: this.turKodu,
        TurAdi: this.turAdi,
        Notlar: this.turNotlar,
        Gece: this.turGece,
        Gunduz: this.turGunduz,
        Aktif: this.turAktif,
        KategoriId: this.turKategoriID,
        UrunGrubuId: this.turUrunGrupID,
        Kontenjan: this.turKontenjan,
        Program: prmprogramlar,
        VarisParkur: this.VarisParkur,
        DonusParkur: this.DonusParkur,
        BaslangicNoktasi: this.BaslangicNoktasi,
        BaslangicTarihi:this.BaslangicTarihi,
        BitisTarihi:this.BitisTarihi
      };

      var api = "Coper/PaketInsert";
      if (this.isUpdate) {
        api = "Coper/PaketEdit"
      }

      tool.api_file_post2(this, api, this.uploadedFiles, params).then(
        (response) => {
          if (response.body.Status == true) {
            this.text1 = 'Kayıt Başarılı';
            this.snackbar = true;

            var url = '#/pakettur/turaltpaket';
            setTimeout(() => { window.open(url, '_self') }, 1000)

          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.text1 = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
        }
      );
      // tool.http_post(this, api, params).then(
      //   (response) => {
      //     if (response.body.Status == true) {
      //       this.text1 = 'Kayıt Başarılı';
      //       this.snackbar = true;

      //       var url = '#/pakettur/turaltpaket';
      //       setTimeout(() => {  window.open(url, '_self') }, 1000)

      //     } else {
      //       this.text1 = response.body.ErrorList[0];
      //       this.snackbar = true;
      //     }
      //   },
      //   (response) => {
      //     this.text1 = "Hata Oluştu, tekrar deneyiniz";
      //     this.snackbar = true;
      //   }
      // );

    },
    HataYonetimi(response, request, baslik) {
      this.mukellefScroll = false
      if (response.status === 500) {
        //Internal Server Error
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable -" + baslik;
        this.snackbar = true;
      }
    },

    getparabirimi() {
      return helpers.getparabirimi()
    },
    getFiyatAltGrup() {
      let params = {
        TanitimTip: 12,
      };

      tool.http_post(this, "GenelTipTanitimList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.fiyatAltGruplar = response.body.data;

          } else {
            this.text1 = response.body.ErrorList[0];

            this.snackbar = true;
          }
        },

        (response) => {
          this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    getFiyatAnaGrup() {
      let params = {
        TanitimTip: 11,
      };

      tool.http_post(this, "GenelTipTanitimList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.fiyatAnaGruplar = response.body.data;

          } else {
            this.text1 = response.body.ErrorList[0];

            this.snackbar = true;
          }
        },

        (response) => {
          this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    getkategoriler() {
      let params = {
        TanitimTip: 9,
      };

      tool.http_post(this, "GenelTipTanitimList", params).then(
        (response) => {
          if (response.body.Status == true) {

            this.kategoriler = response.body.data;

          } else {
            this.text1 = response.body.ErrorList[0];

            this.snackbar = true;
          }
        },

        (response) => {
          this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    getParkurs() {
      var params1 = {
        CompanyCode: this.credentials.SirketKodu
      }
      this.classdialog = false
      this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.Parkurs = response.body

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'


          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'


          this.snackbar = true
        }
      })
    },

    getImage(resim) {
      var params = {
        FileCode: resim.FileCode,
      };
      tool.http_post(this, "BinaryFileLoadBase64", params).then(
        (response) => {
          if (response.body.Status == true) {
            //this.mesaj = "Açıklamalar kaydedildi.";
            //this.snackbar = true;
            this.fileBase64 = response.body.data.imageBase64;
            var url = URL.createObjectURL(
              this.base64toBlob(this.fileBase64, "image/jpeg")
            );
            this.files.push({
              Id: resim.Id,
              url: url,
              IsMain: resim.IsMain,
              silinecek: false
            });
          } else {
            //this.mesaj = response.body.ErrorList[0];
            //this.snackbar = true;
          }
        },
        (response) => {
          //this.mesaj = "Hata oluştu, tekrar deneyiniz";
          //this.snackbar = true;
        }
      );
    },

    geturungruplari() {
      let params = {
        TanitimTip: 10,
      };

      tool.http_post(this, "GenelTipTanitimList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.urungruplari = response.body.data;

          } else {
            this.text1 = response.body.ErrorList[0];

            this.snackbar = true;
          }
        },

        (response) => {
          this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },

    izinVerilenAcenteKaldır(acenteKod) {
      this.Programlar.FiyatGruplari.find(x => x.Id === this.selectedfiyatgrup.Id)
        .AltGruplar.find(x => x.Id == this.selectedPaketAltGrup.Id).PaketAltGrupAcenteler.find(x => x.AcentaKod == acenteKod).silinecek = true;
    },
    AcenteBul(e) {
      var prm = {
        saticiTip: 4,
        saticiKodu: null,
        sqlLike: e,
        limit: 100
      };
      tool.http_post(this, "SaticiList", prm).then(
        response => {
          if (response.body.Status == true) {
            if (response.body.SaticiList.length > 0) {
              this.acenteList = response.body.SaticiList
            }
          }
        }
      );
    },
    AcenteAltGrupIzinVer(acenteKod) {
      this.Programlar.FiyatGruplari.find(x => x.Id === this.selectedfiyatgrup.Id)
        .AltGruplar.find(x => x.Id == this.selectedPaketAltGrup.Id).PaketAltGrupAcenteler.push({
          Id: 0,
          PaketAltGrupId: this.selectedPaketAltGrup.Id,
          AcentaKod: acenteKod,
          silinecek: false
        });
    },
    getDateNow: getDateNow,

  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    }
  },
  beforeMount: beforeMount,
  components: {
    'parainput': parainput,
    yuzdeinput,
    tarihim,
    yetkidialog,
    hatadialog,
    cariaracomp,
    analizcomp,
    loadingcomp,
    muhasebekoducomp,
    snackbarcomp,
    sayiinput,
    draggable,
    genelarama
  },
  watch: {

  }
}



function beforeMount() {

}

function getDateNow() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = '0' + dd
  }

  if (mm < 10) {
    mm = '0' + mm
  }
  today = yyyy + '-' + mm + '-' + dd
  return today
}


</script>

<style></style>